/** User-facing titles and short descriptions for standard HTTP status codes. */
export const HTTP_ERROR_COPY = {
  400: {
    title: "Bad request",
    description:
      "The server could not understand this request. Check the address or try again from the previous page.",
  },
  401: {
    title: "Sign-in required",
    description: "You need to sign in to access this page or resource.",
  },
  403: {
    title: "Access denied",
    description: "You do not have permission to view this content.",
  },
  404: {
    title: "Page not found",
    description:
      "We could not find a page at this address. It may have been moved or the link may be incorrect.",
  },
  405: {
    title: "Method not allowed",
    description: "This action is not supported here. Please use the site navigation or go back.",
  },
  408: {
    title: "Request timed out",
    description: "The request took too long. Please check your connection and try again.",
  },
  409: {
    title: "Conflict",
    description: "This request could not be completed because it conflicts with the current state. Try again or contact us if it persists.",
  },
  410: {
    title: "Gone",
    description: "This page or resource is no longer available.",
  },
  413: {
    title: "Payload too large",
    description: "The data sent was too large for the server to accept. Try a smaller file or shorter form.",
  },
  415: {
    title: "Unsupported type",
    description: "The format of the request is not supported.",
  },
  422: {
    title: "Could not process",
    description: "The information provided could not be processed. Please review it and try again.",
  },
  429: {
    title: "Too many requests",
    description: "You have sent too many requests in a short time. Please wait a moment and try again.",
  },
  500: {
    title: "Server error",
    description:
      "Something went wrong on our side. We have been notified. Please try again in a few minutes.",
  },
  502: {
    title: "Bad gateway",
    description: "Our service received an invalid response from another system. Please try again shortly.",
  },
  503: {
    title: "Service unavailable",
    description: "The site is temporarily unavailable, often due to maintenance or high load. Please try again soon.",
  },
  504: {
    title: "Gateway timeout",
    description: "A server upstream did not respond in time. Please try again.",
  },
  default: {
    title: "Something went wrong",
    description: "An unexpected problem occurred. Please try again or return to the home page.",
  },
};

export function getHttpErrorCopy(code) {
  const n = Number(code);
  if (!Number.isFinite(n) || n < 100 || n > 599) {
    return HTTP_ERROR_COPY.default;
  }
  return HTTP_ERROR_COPY[n] || {
    title: `Error ${n}`,
    description: HTTP_ERROR_COPY.default.description,
  };
}
